import { gql } from '@apollo/client';
export const EP_ANCESTORS_DETAILS_FIELDS = gql `
  fragment EPAncestorsDetailsFields on NodeAncestorsDetails {
    community {
      id
      data {
        title
      }
    }
    examLevel {
      id
      data {
        title
      }
    }
    writtenSubject {
      id
      data {
        title
      }
    }
    writtenQP {
      id
      data {
        dateNL
        label
      }
    }
    oralsSubject {
      id
      data {
        title
      }
    }
    oralsQP {
      id
      data {
        dateNL
        label
      }
    }
  }
`;
